var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerSettingsNew = function SvgPowerSettingsNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "power_settings_new_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#power_settings_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12V4q0-.424.287-.712A.97.97 0 0 1 12 3q.424 0 .713.288Q13 3.575 13 4v8q0 .424-.287.713A.97.97 0 0 1 12 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12m1 9a8.65 8.65 0 0 1-3.488-.712A9.2 9.2 0 0 1 5.65 18.35a9.2 9.2 0 0 1-1.938-2.863A8.65 8.65 0 0 1 3 12q0-1.725.638-3.312A9.2 9.2 0 0 1 5.425 5.85q.275-.3.7-.3t.725.3a.85.85 0 0 1 .25.688q-.026.411-.3.737a7.1 7.1 0 0 0-1.325 2.162A7 7 0 0 0 5 12q0 2.9 2.05 4.95T12 19q2.925 0 4.962-2.05T19 12q0-1.35-.475-2.588a6.8 6.8 0 0 0-1.35-2.187q-.275-.3-.288-.7a.88.88 0 0 1 .263-.675q.3-.3.725-.3t.7.3a8.8 8.8 0 0 1 1.8 2.838A9 9 0 0 1 21 12a8.65 8.65 0 0 1-.712 3.488 9.3 9.3 0 0 1-1.925 2.862 9 9 0 0 1-2.85 1.938A8.7 8.7 0 0 1 12 21"
  }))));
};
export default SvgPowerSettingsNew;